<template>
  <div>
    <viewTable
        ref="viewTable"
        :limits="limits"
        :columns-property="columnsProperty"
        :filter.sync="filter"
        hide-show-hide-btn
        module="basic"
        url="esops/page"
        @addOrEdit="addEditHandle"
        @reset="resetHandle"
        @select="selectHandle">
      <template v-if="limits.editAuth || limits.delAuth" slot="otherBtn">
        <el-button v-if="limits.delAuth" type="primary" @click="handleFileOpen">文件启用</el-button>
        <el-button v-if="limits.delAuth" type="danger" @click="handleFileDisable">文件冻结</el-button>
        <el-button :loading="downloadLoading" type="primary" @click="downloadBatch">批量下载PDF</el-button>
        <el-button
            v-if="limits.downLoadAuth"
            :loading="originDownloadLoading"
            type="primary"
            @click="originDownloadBatch">
          批量下载原文件
        </el-button>
      </template>
      <template slot="actionBtn" slot-scope="scope">
        <el-button
            v-if="limits.bindingAuth"
            :disabled="scope.row.status < 3"
            type="primary"
            @click="$refs.esopMaterial.open(scope.row)">
          物料绑定
        </el-button>
        <el-button
            v-if="limits.editAuth || limits.forceEditAuth"
            :disabled="scope.row.status === 2 || (!limits.forceEditAuth && scope.row.createId !== userId)"
            type="primary"
            @click="$refs.editPage.open(scope.row.id)">
          编辑
        </el-button>
        <el-button
            v-if="limits.editAuth || limits.forceDeleteAuth"
            :disabled="!limits.forceDeleteAuth && (scope.row.auditStatus > 1 || scope.row.createId !== userId)"
            type="danger"
            @click="handleDelete(scope.row)">
          删除
        </el-button>
      </template>
      <template #adSearch>
        <el-form :inline="true" :model="filter" label-width="90px" @keyup.enter.native="loadData(1)">
          <el-form-item label="文件类型">
            <el-input v-model.trim="filter.fileType" placeholder="请输入文件类型" clearable/>
          </el-form-item>
          <el-form-item label="文件名称">
            <el-input v-model.trim="filter.fileName" placeholder="请输入文件名称" clearable/>
          </el-form-item>
          <el-form-item label="是否审核">
            <el-select v-model="filter.isAudit" clearable placeholder="请选择是否审核">
              <el-option :value="true" label="是"/>
              <el-option :value="false" label="否"/>
            </el-select>
          </el-form-item>
          <el-form-item label="文件状态">
            <el-select v-model="filter.status" clearable placeholder="请选择文件状态">
              <el-option :value="0" label="冻结"/>
              <el-option :value="1" label="待审核"/>
              <el-option :value="2" label="审核中"/>
              <el-option :value="3" label="启用"/>
            </el-select>
          </el-form-item>
          <el-form-item v-if="filter.status === 2" label="审核状态">
            <el-select v-model="filter.status" clearable placeholder="请选择审核状态">
              <el-option :value="2" label="工艺负责人审核"/>
              <el-option :value="3" label="生产确认"/>
              <el-option :value="4" label="质量审核"/>
            </el-select>
          </el-form-item>
          <el-form-item label="物料号">
            <el-input v-model.trim="filter.materialNo" placeholder="请输入物料号" clearable/>
          </el-form-item>
          <el-form-item label="创建人">
            <el-input v-model.trim="filter.createName" placeholder="请输入创建人" clearable/>
          </el-form-item>
          <el-form-item label="最后更新人">
            <el-input v-model.trim="filter.updateName" placeholder="请输入最后更新人" clearable/>
          </el-form-item>
          <el-form-item label="创建时间">
            <el-date-picker
                v-model="createTimeRange"
                type="daterange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                value-format="yyyy-MM-dd"
                @change="dateRangeChange('createTimeRange', 'startDate', 'endDate')"/>
          </el-form-item>
          <el-form-item label="最后更新时间">
            <el-date-picker
                v-model="updateDateRange"
                type="daterange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                value-format="yyyy-MM-dd"
                @change="dateRangeChange('updateDateRange', 'updateDateStart', 'updateDateEnd')"/>
          </el-form-item>
        </el-form>
      </template>
    </viewTable>
    <esop-edit ref="editPage" @save-success="getList()"/>
    <esop-material-list ref="esopMaterial" @save-success="getList()"/>
    <esop-operation-record ref="operationRecord"/>
  </div>
</template>

<script>
  import viewTable from "@/components/ViewTable.vue";
  import loginUtil from "@/util/loginUtil";
  import EsopEdit from "@/views/information/ESOPV2/EsopEdit.vue";
  import EsopMaterialList from "@/views/information/ESOPV2/EsopMaterialList.vue";
  import EsopOperationRecord from "@/views/information/ESOPV2/EsopOperationRecord.vue";

  export default {
    name: "EsopList",
    components: {EsopOperationRecord, EsopMaterialList, EsopEdit,  viewTable},
    data() {
      return {
        limits: {
          addAuth: this.$auth(337),
          editAuth: this.$auth(337),
          delAuth: this.$auth(338),
          bindingAuth: this.$auth(339),
          forceDeleteAuth: this.$auth(341),
          forceEditAuth: this.$auth(343),
          downLoadAuth: this.$auth(340),
        },
        userId: loginUtil.getUserId(),
        downloadLoading: false,
        originDownloadLoading: false,
        selection: [],
        createTimeRange: [],
        updateDateRange: [],
        filter: {
          fileType: "",
          fileName: "",
          createName: "",
          updateName: "",
          materialNo: "",
          needAudit: "",
          status: "",
          auditStatus: "",
          startDate: "",
          endDate: "",
          createDate: "",
          updateDate: "",
          updateDateStart: "",
          updateDateEnd: "",
        },
        columnsProperty: [
          {
            key: "fileType",
            width: 160,
            align: "center",
          },
          {
            key: "fileName",
            width: 240,
            align: "center",
            tooltip: true,
            render: (h, params) => {
              return h(
                "span",
                {
                  style: {
                    color: "#2d8cf0",
                    cursor: "pointer",
                  },
                  on: {
                    click: () => {
                      this.previewPage(params.row);
                    },
                  },
                },
                params.row.fileName,
              );
            },
          },
          {
            key: "fileSuffix",
            width: 60,
            align: "center",
          },
          {
            key: "statusDesc",
            width: 120,
            align: "center",
            render: (scope) => {
              return (<div style="display: flex;justify-content: center">
              <el-tag type={
                scope.row.status === 0 ? "danger" 
                : scope.row.status === 1 ? "info" 
                : scope.row.status === 3 ? "success" 
                : "primary"}
                >{scope.row.statusDesc}</el-tag>
                <el-button  v-if="scope.row.operationCount > 0 && (scope.row.status === 0 || scope.row.status === 3)" 
                type="text" 
                onClick={this.$refs.operationRecord.open(scope.row.id)}
              >记录</el-button>
            </div>);
            },
          },
          {
            key: "needAuditDesc",
            width: 80,
            align: "center",
          },
          {
            key: "pdfPageSize",
            width: 60,
            align: "center",
          },
          {
            key: "note",
            width: 150,
            align: "center",
          },
          {
            key: "materialNos",
            width: 200,
            align: "center",
          },
          {
            key: "createName",
            width: 100,
            align: "center",
          },
          {
            key: "createTime",
            width: 135,
            align: "center",
          },
          {
            key: "updateName",
            width: 100,
            align: "center",
          },
          {
            key: "updateDate",
            width: 135,
            align: "center",
          },
          {
            key: "action",
            width: 250,
            slot: "action",
            fixed: "right",
          },
        ],
      };
    },
    mounted() {
      this.getList();
    },
    methods: {
      getList(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },
      handleDelete(row) {
        this.$confirm(`确定删除文件 ${row.fileName} 吗?`, "提示", {type: "warning"}).then(() => {
          this.$http.delete("basic", "esops", row.id).then(() => {
            this.getList();
            this.$message.success("删除成功");
          });
        });
      },
      previewPage(row) {
        this.$router.push({
          path: "/EsopPreview",
          query: {
            billId: row.id,
          },
        });
      },
      handleFileOpen() {
        if (this.selection.length < 1) {
          this.$message.error("请至少选择一条记录");
          return;
        }
        let param = this.selection.map(item => item.id);
        this.$confirm("确定启用所选文件吗?", "提示", {type: "warning"}).then(() => {
          this.$http
            .post("basic", "esops/enable", param)
            .then(() => {
              this.getList();
              this.$message.success("操作成功");
            });
        });
      },
      handleFileDisable() {
        if (this.selection.length < 1) {
          this.$message.error("请至少选择一条记录");
          return;
        }
        let param = this.selection.map(item => item.id);
        this.$confirm("确定冻结所选文件吗?", "提示", {type: "warning"}).then(() => {
          this.$http
            .post("basic", "esops/freeze", param)
            .then(() => {
              this.getList();
              this.$message.success("操作成功");
            });
        });
      },
      downloadBatch() {
        if (this.selection.length < 1) {
          this.$message.error("请至少选择一条记录");
          return;
        }
        this.downloadLoading = true;
        let param = this.selection.map(item => item.id);
        this.$http
          .postForFile("basic", "esops/download/batch/0", param)
          .then(res => {
            let blob = new Blob([res.data]);
            let fileName = decodeURI(res.headers.filename);
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              navigator.msSaveBlob(blob, fileName);
            } else {
              let a = document.createElement("a");
              a.href = URL.createObjectURL(blob);
              a.download = fileName;
              a.style.display = "none";
              document.body.appendChild(a);
              a.click();
              URL.revokeObjectURL(a.href);
              document.body.removeChild(a);
            }
          }).finally(() => {
            this.downloadLoading = false;
          });
      },
      originDownloadBatch() {
        if (this.selection.length < 1) {
          this.$message.error("请至少选择一条记录");
          return;
        }
        this.originDownloadLoading = true;
        let param = this.selection.map(item => item.id);
        this.$http
          .postForFile("basic", "esops/download/batch/1", param)
          .then(res => {
            let blob = new Blob([res.data]);
            let fileName = decodeURI(res.headers.filename);
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              navigator.msSaveBlob(blob, fileName);
            } else {
              let a = document.createElement("a");
              a.href = URL.createObjectURL(blob);
              a.download = fileName;
              a.style.display = "none";
              document.body.appendChild(a);
              a.click();
              URL.revokeObjectURL(a.href);
              document.body.removeChild(a);
            }
          }).finally(() => {
            this.originDownloadLoading = false;
          });
      },
      dateRangeChange(timeRange, timeStart, timeEnd) {
        if (this[timeRange]) {
          this.filter[timeStart] = this[timeRange][0];
          this.filter[timeEnd] = this[timeRange][1];
        } else {
          this.filter[timeStart] = "";
          this.filter[timeEnd] = "";
        }
      },
      // 删除
      deleteHandle(row) {
        this.$confirm("确定删除吗?", "提示", {type: "warning"}).then(() => {
          this.$http.delete("basic", "sapSalesOrders", row.pkId).then((resp) => {
            if (resp.success) {
              this.loadData();
              this.$message.success("删除成功");
            }
          });
        });
      },
      resetHandle(filter) {
        this.filter = Object.assign(this.filter, filter);
      },
      addEditHandle(row) {
        if (row) {
          this.$refs.editPage.open(row.id);
        } else {
          this.$refs.editPage.open();
        }
      },
      selectHandle(selection) {
        this.selection = selection;
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
